import { type SxProps, type Theme } from '@mui/material'

/** Shared chrome for the collection wizard steps (Getting Started → Program Status → Buildings Without). */
export const stepStyles = {
  intro: {
    mb: '24px'
  } satisfies SxProps<Theme>,
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    mt: '32px'
  } satisfies SxProps<Theme>,
  backButton: {
    backgroundColor: 'var(--blue-300)',
    '&:hover': { backgroundColor: 'var(--blue-500)' }
  } satisfies SxProps<Theme>,
  continueButton: {
    backgroundColor: 'var(--blue-700)',
    '&:hover': { backgroundColor: 'var(--blue-900)' }
  } satisfies SxProps<Theme>
}
